import * as types from '../mutation-types';
import { unionState, toDateTimeString } from '../helpers';

const state = () => ({
	branches: [],
});

const actions = {
	fetchEverything({ commit }) {
		return axios.get('/api/settings/branches/all').then(response => {
			commit(types.STORE_ALL_BRANCHES, response.data);

			return response.data;
		});
	},

	fetchAll({ commit }, { restaurantId }) {
		return axios.get(`/api/restaurants/${restaurantId}/branches`).then(response => {
			commit(types.STORE_BRANCHES, response.data);

			return response.data;
		});
	},

	fetch({ commit }, { restaurantId, branchId }) {
		return axios.get(`/api/restaurants/${restaurantId}/branches/${branchId}`).then(response => {
			commit(types.STORE_BRANCH, response.data);

			return response.data;
		});
	},

	create({ commit }, { restaurantId, name, description, location, opens, tags, contactInfo, deliveryZone, can_reserve_tables }) {
		return axios.post(`/api/restaurants/${restaurantId}/branches`, {
			name,
			description,
			location,
			opens,
			tags,
			contact_info: contactInfo,
			delivery_zone: deliveryZone,
			can_reserve_tables,
		}).then(response => {
			commit(types.STORE_BRANCH, response.data);

			return response.data;
		});
	},

	update({ commit }, { restaurantId, branchId, name, description, location, opens, tags, contactInfo, deliveryZone, can_reserve_tables }) {
		return axios.put(`/api/restaurants/${restaurantId}/branches/${branchId}`, {
			name,
			description,
			location,
			opens,
			tags,
			contact_info: contactInfo,
			delivery_zone: deliveryZone,
			can_reserve_tables,
		}).then(response => {
			commit(types.STORE_BRANCH, response.data);

			return response.data;
		});
	},

	delete({ commit }, { restaurantId, branchId }) {
		return axios.delete(`/api/restaurants/${restaurantId}/branches/${branchId}`).then(response => {
			commit(types.DELETE_BRANCH, branchId);
		});
	},

	restore({ commit }, { restaurantId, branchId }) {
		return axios.patch(`/api/restaurants/${restaurantId}/branches/${branchId}`).then(response => {
			commit(types.RESTORE_BRANCH, branchId);
		});
	}
};

const mutations = {
	[types.STORE_ALL_BRANCHES](state, branches) {
		state.branches = branches;
	},

	[types.STORE_BRANCHES](state, branches) {
		state.branches = unionState(state.branches, branches);
	},

	[types.STORE_BRANCH](state, branch) {
		state.branches = unionState(state.branches, [branch]);
	},

	[types.DELETE_BRANCH](state, id) {
		const branch = state.branches.find(b => b.id === id);
		branch.deleted_at = toDateTimeString(new Date());
	},

	[types.RESTORE_BRANCH](state, id) {
		const branch = state.branches.find(b => b.id === id);
		branch.deleted_at = null;
	},
};

const getters = {
	getById: state => id => state.branches.find(b => b.id === id),
	getAll: state => id => state.branches.filter(b => b.restaurant_id === id),
};

export default {
	namespaced: true,
	state,
	mutations,
	actions,
	getters
};